import React, {useEffect, useState} from "react";
import {createSearchParams, useNavigate} from "react-router-dom";
import axios from "axios";
import {ISurvey} from "../../data/interfaces/ISurvey"
import {SurveyService} from "../../data/services/SurveyService";
import {SurveyApi} from "../../data/api/SurveyApi";
import "./style.scss";


export function SurveyListView() {

    const navigate = useNavigate();

    const surveyService = SurveyService();

    const user = localStorage.getItem('user');

    const [surveyList, setSurveyList] = useState<ISurvey[]>([])


    const loadSurveys = async () => {
        const surveys = await surveyService.getSurveys();
        setSurveyList(surveys);
    }

    const selectSurvey = (id: string) => {
        navigate({
            pathname: "/responses/" + id.toString()
        });
    }

    const logout = async () => {
        await surveyService.logout();
        localStorage.removeItem('user');
        navigate({
            pathname: "/",
        });
    }


    useEffect(() => {
        loadSurveys();
    }, []);

    useEffect(() => { }, [user]);

    return (
        <>
            <div className="survey-list-wrapper">
                <div className="survey-list-container">
                    {
                        surveyList.map((survey, surveyIndex) => {
                            return (
                                <button key={surveyIndex}
                                        className="survey-list-item"
                                        onClick={() => selectSurvey(survey.id)}>
                                    {
                                        survey.title
                                    }
                                </button>
                            )
                        })
                    }
                </div>
            </div>

            {
                user !== null && (
                    <div className="user-toast">
                        <span>{user}</span>
                        <button onClick={() => logout()}>Выйти</button>
                    </div>
                )
            }
        </>
    );
}